"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentersDeclineText = void 0;
var React = require("react");
var RentersDeclineText = /** @class */ (function () {
    function RentersDeclineText() {
        this.underwritingResultCustomerWordings = [
            {
                key: "UR001",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "Please enter your postcode to continue.")
            },
            {
                key: "UR002",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't find your address, please check your address is correct.")
            },
            {
                key: "UR003",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure addresses in N Ireland, the Channel Islands or Isle of Man.")
            },
            {
                key: "UR004",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure this type of property.")
            },
            {
                key: "UR005",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can only insure properties with up to two housemates living there.")
            },
            {
                key: "UR006",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can only insure properties with up to six adults living there.")
            },
            {
                key: "UR007",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can only insure properties with up to 4 bedrooms.")
            },
            {
                key: "UR008",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can only insure properties with up to 4 bathrooms.")
            },
            {
                key: "UR009",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure this type of property.")
            },
            {
                key: "UR010",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we currently can't accept more than one claim.")
            },
            {
                key: "UR011",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR012",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure properties that have been previously flooded.")
            },
            {
                key: "UR013",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR014",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR015",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR016",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR017",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "Please enter a valid email address.")
            },
            {
                key: "UR018",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR019",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR020",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR021",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR022",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR023",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR025",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
            {
                key: "UR027",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure this type of property.")
            },
            {
                key: "UR028",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...you can't insure more than 10 items.")
            },
            {
                key: "UR029",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "The item you just added has taken the total value of your specified items above the contents limit you have chosen.",
                    React.createElement("br", null),
                    "Please review your contents limit to ensure this covers the total value of all of your possessions.")
            },
            {
                key: "UR030",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "Flow provides content insurance for tenants only.",
                    React.createElement("br", null),
                    "If you are a homeowner, and you want to cover your personal possessions within the home, it's best to get a traditional home insurance quote instead.")
            },
            {
                key: "UR031",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure items which have a combined value of more than \u00A320,000.")
            },
            {
                key: "UR032",
                value: React.createElement("p", null,
                    "Good news - your contents are already covered under Flow insurance subscription.",
                    ' ',
                    React.createElement("br", null),
                    "To view your cover details or make a change, ",
                    React.createElement("a", { href: "/dashboard", className: "a-bold" }, "go to your account"),
                    ".")
            },
            {
                key: "UR033",
                value: React.createElement("p", null,
                    "Sorry...",
                    React.createElement("br", null),
                    "...we can't insure you.")
            },
        ];
    }
    ;
    return RentersDeclineText;
}());
exports.RentersDeclineText = RentersDeclineText;
//# sourceMappingURL=RentersDeclineText.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/declineTextOutputWidget/RentersDeclineText.js
// module id = 3656
// module chunks = 0